module.exports = __webpack_public_path__ + "static/img/qq_img_3.0c2aee0b.png";